const firstTimeModalHomeNewsletter = {
  'first-time-modal-home-title': 'Pandito Newsletter',
  'first-time-modal-home-body': 'Möchtest du informiert bleiben, wissen, an welchen Veranstaltungen wir teilnehmen und was es Neues bei Pandito gibt? Dann melde dich für unseren Newsletter an!',
  'first-time-modal-home-info': 'Der Newsletter wird von dieser E-Mail-Adresse verschickt: panditoicecream@gmail.com'
};

export default firstTimeModalHomeNewsletter;
